<template>
  <div v-if="hasErrors" class="validation-hint uk-text-danger">
    <ul class="errors uk-list">
      <li class="error" v-for="error in errors">
        {{error}}
      </li>
    </ul>
  </div>
</template>

<script>
import Validation from '@/mixins/Validation';

export default {
  name: 'validation-hint',
  mixins: [Validation],
};
</script>

<style lang="scss" scoped>
* + .validation-hint {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// ValidationHint.vue?ebcb529e